import { Link } from '@mui/material'
import styled from 'styled-components'

const TextLink = styled(Link)`
  color: ${(p) => p.theme.palette.primary.light};
  text-decoration: none;
`

export default TextLink
